var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#8D181B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.454 8.8493C14.859 8.8493 15.1875 9.16993 15.1875 9.56649C15.1875 9.96305 14.859 10.2837 14.454 10.2837C14.1446 10.2837 13.8797 10.0958 13.7722 9.83087H11.6798L10.908 11.2034C10.7809 11.4295 10.4327 11.3626 10.4023 11.1066L10.2291 9.64018L9.58781 14.3956C9.54506 14.7117 9.072 14.6971 9.05006 14.3787L8.52413 6.69099L7.96725 11.7839C7.9335 12.0876 7.48744 12.1034 7.43287 11.8024L6.84338 8.56468L6.57113 9.63062C6.55579 9.68832 6.52173 9.7393 6.47429 9.77554C6.42684 9.81179 6.3687 9.83125 6.309 9.83087H3.645C3.49594 9.83087 3.375 9.71274 3.375 9.56649C3.375 9.42024 3.49594 9.30212 3.645 9.30212H6.0975L6.62569 7.23718C6.69656 6.96043 7.10269 6.97449 7.15444 7.25518L7.632 9.88149L8.31769 3.6113C8.35312 3.29012 8.83406 3.29912 8.856 3.62143L9.40781 11.6877L9.97819 7.45543C10.0198 7.14662 10.4783 7.14999 10.5148 7.45937L10.8422 10.2241L11.2832 9.4388C11.307 9.39708 11.3415 9.36244 11.3831 9.33842C11.4247 9.3144 11.472 9.30187 11.52 9.30212H13.7722C13.828 9.16744 13.9227 9.05244 14.0441 8.97179C14.1655 8.89113 14.3082 8.84849 14.454 8.8493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpx);
export default __webpack_public_path__ + "static/media/rpx.9769c92f44c447e1ef745b457a0ec32c.svg";
export { ForwardRef as ReactComponent };